export const ACTION_DELETE = 'supprimer';
export const ACTION_SAVE = 'enregistrer';
export const ACTION_ENVOYER = 'envoyer';
export const ACTION_DUPLICATION = 'dupliquer';
export const ACTION_MASS_DELETE = 'supprimerEnMasse';
export const ACTION_MASS_EDITION = 'editionEnMasse';
export const ACTION_MASS_FACTURATION = 'facturer';
export const ACTION_MASS_ANNULATION = 'annulerEnMasse';
export const ACTION_MASS_REALISATION = 'realiserEnMasse';
export const ACTION_MASS_EN_ATTENTE = 'EnAttenteEnMasse';
export const ACTION_MASS_EN_COURS = 'EncoursEnMasse';
export const ACTION_MASS_PLANIFIE = 'PlanifieEnMasse';
export const ACTION_MASS_CLOTURER = 'CloturerEnMasse';
export const ACTION_MASS_ARCHIVER = 'ArchiverEnMasse';
export const ACTION_MASS_DESARCHIVER = 'DesarchiverEnMasse';
export const ACTION_MASS_ENREGISTRER = 'EnregistrerEnMasse';
export const ACTION_MASS_CHANGER_COMMERCIAL = 'ChangerCommercialEnMasse';
export const ACTION_MASS_INDEXATION = 'IndexationEnMasse';
export const ACTION_MASS_AJOUTER_SECTEUR = 'AjouterSecteurEnMasse';
export const ACTION_MASS_SUPPRIMER_SECTEUR = 'SupprimerSecteurEnMasse';
export const ACTION_MASS_IMPRESSSION = 'ImpressionEnMasse';
export const ACTION_MASS_A_EXPEDIER = 'AExpedierEnMasse';
export const ACTION_MASS_EXPEDIER = 'ExpedierEnMasse';
export const ACTION_MASS_DEMONTER = 'DemonterEnMasse';
export const ACTION_MASS_ETAT_NON_RENOUVELLE = 'EtatNonRenouvelleEnMasse';
